import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { Loader } from "../../components/loader";
import { 
  addAutoUnsubscribeKeyword, 
  getAutoUnsubscribeKeywords, 
  updateAutoUnsubscribeKeyword, 
  deleteAutoUnsubscribeKeyword 
} from "../../actions/notificationManager";

const $ = window.$;
const initialState = {
  newKeyword: "",
  keywords: [],
  editId: "",
  editType: "",
  selectedId: "",
  loadingAdd: false,
  loadingEdit: false,
  loadingDelete: false,
};

class AutoUnsubscribeKeywords extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  componentDidMount() {
    this.props.getAutoUnsubscribeKeywords();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.keywords !== nextProps.keywords) {
      this.setState({ keywords: nextProps.keywords });
    }

    if (this.props.getKeywordsError !== nextProps.getKeywordsError) {
      NotificationManager.error("Fail to get keywords");
    }

    if (this.props.addKeyword !== nextProps.addKeyword) {
      this.setState({ newKeyword: "", loadingAdd: false });
      this.props.getAutoUnsubscribeKeywords();
      NotificationManager.success("Keyword added successfully");
    }

    if (this.props.addKeywordError !== nextProps.addKeywordError) {
      this.setState({ newKeyword: "", loadingAdd: false });
      NotificationManager.error("Fail to add keyword");
    }

    if (this.props.updateKeyword !== nextProps.updateKeyword) {
      this.setState({ editId: "", editType: "", loadingEdit: false });
      this.props.getAutoUnsubscribeKeywords();
      NotificationManager.success("Keyword update success");
    }

    if (this.props.updateKeywordError !== nextProps.updateKeywordError) {
      this.setState({ editId: "", editType: "", loadingEdit: false });
      NotificationManager.error("Fail to update keyword");
    }

    if (this.props.deleteKeyword !== nextProps.deleteKeyword) {
      this.setState({ selectedId: "", loadingDelete: false });
      NotificationManager.success("Keyword deleted successfully");
      this.props.getAutoUnsubscribeKeywords();
      $("#confirm_keyword_delete_modal").modal("hide");
    }

    if (this.props.deleteKeywordError !== nextProps.deleteKeywordError) {
      this.setState({ selectedId: "", loadingDelete: false });
      NotificationManager.error("Fail to delete keyword");
      $("#confirm_keyword_delete_modal").modal("hide");
    }
  }

  // Add keyword
  addKeyword = e => {
    e.preventDefault();
    const { newKeyword } = this.state;
    if (newKeyword && newKeyword.trim().length > 0) {
      const data = {
        keyword: newKeyword,
      };
      this.props.addAutoUnsubscribeKeyword(data);
    } else {
      NotificationManager.warning("Please check the input field");
    }
  };

  // Edit keyword
  saveEdit = (e, type) => {
    e.preventDefault();
    const { editId, editType, loadingEdit } = this.state;

    if (editType && editType.trim().length >= 0) {
      if (editType === type) {
        this.setState({ loadingEdit: false, editId: "", editType: "" });
        return true;
      }
      const data = {
        keyword: editType
      };
      this.props.updateAutoUnsubscribeKeyword(editId, data);
      this.setState({ loadingEdit: true });
    } else {
      NotificationManager.warning("Please check the input field");
    }
  };

  cancelEdit = () => {
    this.setState({ editId: "", editType: "" });
  };

  toggleEdit = (id, type) => {
    if (this.state.editId === id) {
      this.setState({ editId: "" });
      return true;
    }

    this.setState({ editId: id, editType: type });
  };

  // Delete keyword
  openConfirmDeleteModal = (id) => {
    this.setState({ selectedId: id });
    $("#confirm_keyword_delete_modal").modal("show");
  };

  deleteKeyword = () => {
    const { selectedId } = this.state;
    this.setState({ loadingDelete: true });
    if (selectedId) {
      this.props.deleteAutoUnsubscribeKeyword(selectedId);
    } else {
      NotificationManager.warning("This keyword not available.");
      this.setState({ loadingDelete: false });
    }
  };

  render() {
    return (
      <div>
        <div className="m-portlet__body">
          <div className="m-form__section m-form__section--first row">
            <div
              className="col-md-12"
              style={{ alignItems: "center", display: "flex" }}
            >
              <div className="m-widget4 m-width-100-perc">
                {this.state.keywords.map((keyword, index) => (
                  <div key={index} className="m-widget4__item">
                    {this.state.editId === keyword.id ? (
                      <div
                        className="col-md-12"
                        style={{ display: "inline-flex" }}
                      >
                        <input
                          type="text"
                          name="editType"
                          onChange={this.onChange}
                          value={this.state.editType}
                          className="form-control m-input mr-2"
                          placeholder=""
                        />
                        <button
                          onClick={e => this.saveEdit(e, keyword.keyword)}
                          className="btn btn-link btn-link-no-deco m-widget4__icon mr-2"
                        >
                          {this.state.loadingEdit ? <Loader size={20} /> : <i className="la la-check"></i>}
                        </button>
                        <button
                          onClick={this.cancelEdit}
                          className="btn btn-link btn-link-no-deco m-widget4__icon"
                        >
                          <i className="la la-close"></i>
                        </button>
                      </div>
                    ) : (
                      <React.Fragment>
                        <div className="m-widget4__img m-widget4__img--icon">
                          <i className="la la-check"></i>
                        </div>
                        <div className="m-widget4__info">
                          <span className="m-widget4__text">
                            {keyword.keyword}
                          </span>
                        </div>
                        <div className="m-widget4__ext">
                          <button
                            onClick={() =>
                              this.toggleEdit(keyword.id, keyword.keyword)
                            }
                            className="btn btn-link btn-link-no-deco m-widget4__icon"
                          >
                            <i className="la la-edit"></i>
                          </button>
                        </div>
                        <div className="m-widget4__ext">
                          <button
                            onClick={e => {
                              e.preventDefault();
                              this.openConfirmDeleteModal(keyword.id);
                            }}
                            className="btn btn-link btn-link-no-deco m-widget4__icon"
                          >
                            <i className="la la-trash-o"></i>
                          </button>
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="m-portlet__foot m-portlet__foot--fit">
          <div className="m-form__actions m--align-right">
            <input
              type="text"
              name="newKeyword"
              onChange={this.onChange}
              value={this.state.newKeyword}
              className="form-control m-input mr-2"
              placeholder="Add new keyword"
            />
            {this.state.loadingAdd ? <div className="mt-4"><Loader size={30} /></div> : 
              <button
                onClick={this.addKeyword}
                className="btn btn-primary m-btn m-btn--icon m-btn--pill mt-4"
              >
                <span>
                  <i className="la la-save"></i>
                  <span>Save</span>
                </span>
              </button>
            }
          </div>
        </div>
        <div
          className="modal fade"
          id="confirm_keyword_delete_modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="ConfirmationModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Confirm to delete keyword
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>
                  If you choose to confirm this type will no longer available.
                  Would you like to confirm?
                </p>
              </div>
              <div className="modal-footer">
                {this.state.loadingDelete == false ? (
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={() => this.deleteKeyword()}
                      className="btn btn-primary m-btn--pill"
                    >
                      Confirm
                    </button>
                  </div>
                ) : (
                  <div className="center-row">
                    <Loader size={50} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  addKeyword: state.notificationManagerReducer.addUnsubscirbeKeyword,
  keywords: state.notificationManagerReducer.getUnsubscribeKeywords,
  updateKeyword: state.notificationManagerReducer.updateUnsubscribeKeyword,
  deleteKeyword: state.notificationManagerReducer.deleteUnsubscribeKeyword,
  addKeywordError: state.notificationManagerReducer.addUnsubscirbeKeywordError,
  getKeywordsError: state.notificationManagerReducer.getUnsubscribeKeywordsError,
  updateKeywordError: state.notificationManagerReducer.updateUnsubscribeKeywordError,
  deleteKeywordError: state.notificationManagerReducer.deleteUnsubscribeKeywordError,
});

const mapDispatchToProps = (dispatch) => ({
  addAutoUnsubscribeKeyword: (data) => {
    dispatch(addAutoUnsubscribeKeyword(data));
  },
  getAutoUnsubscribeKeywords: () => {
    dispatch(getAutoUnsubscribeKeywords());
  },
  updateAutoUnsubscribeKeyword: (id, data) => {
    dispatch(updateAutoUnsubscribeKeyword(id, data));
  },
  deleteAutoUnsubscribeKeyword: (id) => {
    dispatch(deleteAutoUnsubscribeKeyword(id));
  }
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AutoUnsubscribeKeywords));
